import { InputText } from "primereact/inputtext";
import React from "react";

const SearchComponent = ({ globalFilterValue, onGlobalFilterChange }) => {
  return (
    <div className="flex justify-content-end">
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          value={globalFilterValue}
          onChange={onGlobalFilterChange}
          placeholder="Rechercher"
        />
      </span>
    </div>
  );
};

export default SearchComponent;
